<div class="change-administrator">
    <p>{{ 'CHANGE_ADMINISTRATOR.CHANGE_ADMIN_DESCRIPTION' | translate }}</p>
   <bzg-input readonly="true" [(ngModel)]="userName">
     {{ 'CHANGE_ADMINISTRATOR.CURRENT_ADMINISTRATOR' | translate }}
  </bzg-input>
    <bzg-button-primary class="change-administrator__button" (click)="changeAdministrator()">
        {{ 'CHANGE_ADMINISTRATOR.CHANGE_ADMINISTRATOR' | translate }}
    </bzg-button-primary>
</div>
